import { OnboardingSlide } from "@boundary/widgets/onboarding";
import { z } from "zod";
import { LegalStep } from "@boundary/pages/3.login/steps/legal";
import { PhoneStep } from "@boundary/pages/3.login/steps/phone";
import { ValidationDto } from "@domain/dtos/validation.dto";
import { OtpStep } from "@boundary/pages/3.login/steps/otp";
import { NameStep } from "@boundary/pages/3.login/steps/name";

export const LoginFlowData = z.object({
  phone: ValidationDto.phone(),
  name: ValidationDto.required(),
  otp: ValidationDto.otp()
});
export type LoginFlowData = z.infer<typeof LoginFlowData>;
export type LoginFlowSteps = "legal" | "phone" | "otp" | "name";

export const LOGIN_FLOW: OnboardingSlide<LoginFlowData, LoginFlowSteps>[] = [
  {
    step: "legal",
    element: LegalStep
  },
  {
    step: "phone",
    element: PhoneStep
  },
  {
    step: "otp",
    element: OtpStep
  },
  {
    step: "name",
    element: NameStep
  }
];

